import React, { useRef, useState } from "react";
import "./frameModal.scss";
import closeIcon from "../../../images/modal/close-icon.svg";
import useOnClickOutside from "../../../helpers/useOnClickOutside";
import IFrame1 from "../../iFrames/iFrame1/IFrame1";
import { useGetPageQuery } from "../../../redux/services/velmartAPI";
import { getIFrameById } from "../../iFrames/getIFrameById";

const FrameModal = ({ isOpen, setIsOpen, watchingIframeId }) => {
    const modalRef = useRef();

    useOnClickOutside(modalRef, () => setIsOpen(false));

    const { data: file } = useGetPageQuery("files/" + watchingIframeId);

    return (
        <>
            {isOpen && (
                <div className="modal-overlay">
                    {file && (
                        <div className="frameModal" ref={modalRef}>
                            <div className="modal-content">
                                <img
                                    src={closeIcon}
                                    alt="close"
                                    className="modal-content__close-btn"
                                    onClick={() => setIsOpen(false)}
                                />
                                <div className="modal-content__iframe">
                                    {file.iframes.map((iframeData) => {
                                        return getIFrameById(iframeData.id, iframeData, file);
                                    })}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default FrameModal;
